export var TalkingPointTemplateType;
(function (TalkingPointTemplateType) {
    TalkingPointTemplateType["DONUT"] = "donut";
    TalkingPointTemplateType["LARGE_VALUE"] = "large_value";
    TalkingPointTemplateType["LARGE_VALUE_W_CHART"] = "large_value_chart";
})(TalkingPointTemplateType || (TalkingPointTemplateType = {}));
